import { render, staticRenderFns } from "./SingleFileAudioPlayer.vue?vue&type=template&id=5e512846&scoped=true&"
import script from "./SingleFileAudioPlayer.vue?vue&type=script&lang=js&"
export * from "./SingleFileAudioPlayer.vue?vue&type=script&lang=js&"
import style0 from "./SingleFileAudioPlayer.vue?vue&type=style&index=0&id=5e512846&prod&lang=scss&"
import style1 from "./SingleFileAudioPlayer.vue?vue&type=style&index=1&id=5e512846&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e512846",
  null
  
)

export default component.exports